//
// tko.computed - Exports
//
// knockout -> tko changes:
//      Deprecates `dependentObservable` (use `computed`)
//

export {
    computed,
    isComputed,
    isPureComputed,
    pureComputed
} from './computed.js'

export {
    throttleExtender
} from './throttleExtender'

export {
  proxy
} from './proxy'

export {
  when
} from './when'
